<template>
  <div v-show="isActive" class="filter filter-genre"> <!-- v-if="genre.isActive" -->
    <div class="inner">
      <div class="mobile-label">
        {{label}}
        <span class="back-button" @click="closePanel"></span>
      </div>
      <autocomplete
        :items="genre.data"
        :searchKey="'name'"
        :updateKey="'genre'"
        :placeholder="placeholder"
        @update="update"
      >
      </autocomplete>
    </div>
  </div>
</template>

<script>
import AutocompleteDirect from './AutocompleteDirect.vue';

export default {
  props: ['genre', 'isActive', 'label', 'placeholder'],

  methods: {
	update(data) {
      this.$emit('update', data);
    },

    closePanel() {
	  this.$parent.updateGenreToggle(false)
    }

  },

  components: {
    'autocomplete': AutocompleteDirect
  }
}
</script>

<style scoped>
@import './../css/catalog-filters.css';

</style>



// WEBPACK FOOTER //
// src/vue/components/GenreFilter.vue